import cx from "classnames"
import PropTypes from "prop-types"
import React from "react"
import * as css from "./SectionHeader.module.css"

function SectionHeader({
  title,
  subtitle,
  label,
  cta,
  children,
  level = "h2",
  size,
  centered,
  bordered,
  decorated,
  contrasted,
  inverted,
  narrow,
  constrained,
  margin,
  marginTop,
  className,
}) {
  const hero = size === "hero"
  const post = size === "post"

  const classNames = cx(
    css.header,
    {
      [css.centered]: !!centered,
      [css.bordered]: !!bordered,
      [css.constrained]: !!constrained,
      [css.margin]: !!margin,
      [css.marginTop]: !!marginTop,
      [css.marginLight]: margin === "light",
      [css.marginExtraLight]: margin === "extraLight",
      [css.hero]: hero,
      [css.post]: post,
      [css.inverted]: !!inverted,
      [css.narrow]: !!narrow,
      [css.sizeHuge]: size === "huge" || hero || post || level === "h1",
      [css.sizeLarge]: size === "large",
    },
    className
  )

  const Tag = level

  return (
    <Tag className={classNames}>
      {label && (
        <div
          className={cx(css.label, {
            [css.labelDecorated]: decorated,
          })}
        >
          {label}
        </div>
      )}
      {title || children}
      {subtitle && (
        <div
          className={cx(css.subtitle, {
            [css.subtitleHuge]:
              size === "huge" ||
              size === "large" ||
              hero ||
              post ||
              level === "h1",
            [css.subtitleContrasted]: !!contrasted,
          })}
        >
          {subtitle}
        </div>
      )}
      {cta && <div className={css.cta}>{cta}</div>}
    </Tag>
  )
}

SectionHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  label: PropTypes.string,
  level: PropTypes.oneOf(["h1", "h2", "h3"]),
  cta: PropTypes.node,
  size: PropTypes.string,
  children: PropTypes.node,
  centered: PropTypes.bool,
  constrained: PropTypes.bool,
  bordered: PropTypes.bool,
  contrasted: PropTypes.bool,
  decorated: PropTypes.bool,
  inverted: PropTypes.bool,
  narrow: PropTypes.bool,
  margin: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  marginTop: PropTypes.bool,
  className: PropTypes.string,
}

export default SectionHeader
